import * as types from '../services/InvestorType';

function investorReducer(state = {}, action) {
    switch (action.type) {
        case types.GET_INVESTORS_REQUEST:
            return { ...state, isInvestorLoading: true };
        case types.GET_INVESTORS_SUCCESS:
            return { ...state, isInvestorLoading: false, investorList: action.payload };
        case types.GET_INVESTORS_FAILURE:
            return { ...state, isInvestorLoading: false, investorList: [] };

        case types.GET_INVESTOR_BY_ID_REQUEST:
            return { ...state, isInvestorLoading: true };
        case types.GET_INVESTOR_BY_ID_SUCCESS:
            return { ...state, isInvestorLoading: false, investorDetails: action.payload };
        case types.GET_INVESTOR_BY_ID_FAILURE:
            return { ...state, isInvestorLoading: false, investorDetails: null };

        case types.GET_INVESTMENT_VIEW_DETAILS_REQUEST:
            return { ...state, isInvestorLoading: true };
        case types.GET_INVESTMENT_VIEW_DETAILS_SUCCESS:
            return { ...state, isInvestorLoading: false, investmentViewDetails: action.payload };
        case types.GET_INVESTMENT_VIEW_DETAILS_FAILURE:
            return { ...state, isInvestorLoading: false, investmentViewDetails: null };

        case types.GET_INVESTMENT_DETAILS_BY_INVESTMENT_ID_REQUEST:
            return { ...state, isInvestmentDetailsLoading: true };
        case types.GET_INVESTMENT_DETAILS_BY_INVESTMENT_ID_SUCCESS:
            return { ...state, isInvestmentDetailsLoading: false, investmentDetails: action.payload };
        case types.GET_INVESTMENT_DETAILS_BY_INVESTMENT_ID_FAILURE:
            return { ...state, isInvestmentDetailsLoading: false, investmentDetails: null };

        case types.DELETE_INVESTOR_REQUEST:
            return { ...state, isInvestorLoading: true };
        case types.DELETE_INVESTOR_SUCCESS:
            return { ...state, isInvestorLoading: false };
        case types.DELETE_INVESTOR_FAILURE:
            return { ...state, isInvestorLoading: false };

        case types.SAVE_INVESTOR_REQUEST:
            return { ...state, isInvestorSaving: true, investorSaveError: null, investorSaveSuccess: false };
        case types.SAVE_INVESTOR_SUCCESS:
            return { ...state, isInvestorSaving: false, investorSaveError: null, investorSaveSuccess: true };
        case types.SAVE_INVESTOR_FAILURE:
            return { ...state, isInvestorSaving: false, investorSaveError: action.payload, investorSaveSuccess: false };

        case types.DELETE_INVESTMENT_DETAILS_BY_INVESTOR_INVESTMENT_ID_REQUEST:
            return { ...state, isInvestmentDetailsDeleting: true };
        case types.DELETE_INVESTMENT_DETAILS_BY_INVESTOR_INVESTMENT_ID_SUCCESS:
            return { ...state, isInvestmentDetailsDeleting: false };
        case types.DELETE_INVESTMENT_DETAILS_BY_INVESTOR_INVESTMENT_ID_FAILURE:
            return { ...state, isInvestmentDetailsDeleting: false };

        case types.GET_PREFERRED_BULK_DATA_REQUEST:
            return { ...state, isPreferredBulkDataLoading: true };
        case types.GET_PREFERRED_BULK_DATA_SUCCESS:
            return {
                ...state,
                isPreferredBulkDataLoading: false,
                preferredBulkData: action.payload
            };
        case types.GET_PREFERRED_BULK_DATA_FAILURE:
            return { ...state, isPreferredBulkDataLoading: false };

        case types.GET_CATCHUP_BULK_DATA_REQUEST:
            return { ...state, isCatchUpBulkDataLoading: true };
        case types.GET_CATCHUP_BULK_DATA_SUCCESS:
            return {
                ...state,
                isCatchUpBulkDataLoading: false,
                catchUpBulkData: action.payload.catchUpBulkData || [],
                catchUpCurrentUnitPrice: action.payload.currentUnitPrice || '',
                catchUpTotalRecords: action.payload.totalRecords || 0
            };
        case types.GET_CATCHUP_BULK_DATA_FAILURE:
            return { ...state, isCatchUpBulkDataLoading: false };

        case types.GET_HOLDCO_BULK_DATA_REQUEST:
            return { ...state, isHoldCoBulkDataLoading: true };
        case types.GET_HOLDCO_BULK_DATA_SUCCESS:
            return {
                ...state,
                isHoldCoBulkDataLoading: false,
                holdCoBulkData: action.payload.holdCoBulkData || [],
                holdCoCurrentUnitPrice: action.payload.currentUnitPrice || '',
                holdCoTotalRecords: action.payload.totalRecords || 0
            };
        case types.GET_HOLDCO_BULK_DATA_FAILURE:
            return { ...state, isHoldCoBulkDataLoading: false };

        case types.SAVE_PREFERRED_BULK_DATA_REQUEST:
            return { ...state, isPreferredBulkDataLoading: true };
        case types.SAVE_PREFERRED_BULK_DATA_SUCCESS:
            return { ...state, isPreferredBulkDataLoading: false };
        case types.SAVE_PREFERRED_BULK_DATA_FAILURE:
            return { ...state, isPreferredBulkDataLoading: false };

        case types.SAVE_CATCHUP_BULK_DATA_REQUEST:
            return { ...state, isCatchUpBulkDataLoading: true };
        case types.SAVE_CATCHUP_BULK_DATA_SUCCESS:
            return { ...state, isCatchUpBulkDataLoading: false };
        case types.SAVE_CATCHUP_BULK_DATA_FAILURE:
            return { ...state, isCatchUpBulkDataLoading: false };

        case types.SAVE_HOLDCO_BULK_DATA_REQUEST:
            return { ...state, isHoldCoBulkDataLoading: true };
        case types.SAVE_HOLDCO_BULK_DATA_SUCCESS:
            return { ...state, isHoldCoBulkDataLoading: false };
        case types.SAVE_HOLDCO_BULK_DATA_FAILURE:
            return { ...state, isHoldCoBulkDataLoading: false };
        case types.EXPORT_EQUITY_USER_REQUEST:
            return { ...state, isUserLoading: true };
        case types.EXPORT_EQUITY_USER_SUCCESS:
            return { ...state, isUserLoading: false, userEquityExportData: action.payload };
        case types.EXPORT_EQUITY_USER_FAILURE:
            return { ...state, isUserLoading: false, userEquityExportData: null };
        case types.IMPORT_EQUITY_USER_REQUEST:
            return { ...state, isUserLoading: true, importEquityUserSuccess: false };
        case types.IMPORT_EQUITY_USER_SUCCESS:
            return { ...state, isUserLoading: false, userImportData: action.payload, importEquityUserSuccess: true };
        case types.IMPORT_EQUITY_USER_FAILURE:
            return { ...state, isUserLoading: false, userImportData: null, importEquityUserSuccess: false };
        case types.CLEAR_EQUITY_USER_EXPORT:
            return { ...state, userEquityExportData: null };
        case types.CLEAR_IMPORT_EQUITY_USER_SUCCESS:
            return { ...state, importEquityUserSuccess: false, userImportData: null };
        case types.CLEAR_INVESTOR_DETAILS:
            return { ...state, investorDetails: null };
        case types.PUBLISH_INVESTMENT_REQUEST:
            return { ...state, isPublishingInvestment: true, publishInvestmentSuccess: false };
        case types.PUBLISH_INVESTMENT_SUCCESS:
            return { ...state, isPublishingInvestment: false, publishInvestmentSuccess: true };
        case types.PUBLISH_INVESTMENT_FAILURE:
            return { ...state, isPublishingInvestment: false, publishInvestmentSuccess: false };
        case types.CLEAR_PUBLISH_INVESTMENT:
            return { ...state, publishInvestmentSuccess: false };

        case types.FETCH_EQUITY_IMPORT_BATCH_LIST_REQUEST:
            return { ...state, isEquityImportBatchLoading: true };
        case types.FETCH_EQUITY_IMPORT_BATCH_LIST_SUCCESS:
            return {
                ...state,
                isEquityImportBatchLoading: false,
                equityImportBatchList: action.payload?.items || [],
                equityImportBatchTotalRecords: action.payload?.totalRecords || 0,
            };
        case types.FETCH_EQUITY_IMPORT_BATCH_LIST_FAILURE:
            return { ...state, isEquityImportBatchLoading: false, equityImportBatchList: [], equityImportBatchTotalRecords: 0 };

        case types.DOWNLOAD_EQUITY_IMPORT_RECORDS_REQUEST:
            return { ...state, downloadingEquityBatchId: action.payload };
        case types.DOWNLOAD_EQUITY_IMPORT_RECORDS_SUCCESS:
        case types.DOWNLOAD_EQUITY_IMPORT_RECORDS_FAILURE:
            return { ...state, downloadingEquityBatchId: null };
        default:
            return state;
    }
}
export default investorReducer;
